import { UserCollectionRequest } from './user-collection-request';

export class RemovalCollectionRequest extends UserCollectionRequest {
  public reason: string;
  public separationDate: Date
}